import { render, staticRenderFns } from "./Pywx.vue?vue&type=template&id=7338a299&"
import script from "./Pywx.vue?vue&type=script&lang=js&"
export * from "./Pywx.vue?vue&type=script&lang=js&"
import style0 from "./Pywx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports